var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "参考酒店分享",
            visible: _vm.dialogVisible,
            width: "50%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "referHotelImage" },
                [
                  _c("p", { staticStyle: { "font-weight": "bold" } }, [
                    _vm._v(_vm._s(item.dateRangeStrAndCityName)),
                  ]),
                  _vm._l(
                    item.groupReferenceHotelSons,
                    function (item1, index1) {
                      return _c(
                        "div",
                        { key: index1 },
                        [
                          _c("p", { staticStyle: { "font-weight": "bold" } }, [
                            _vm._v(_vm._s(item1.hotelNameAndStar)),
                          ]),
                          _vm._l(item1.roomInfo, function (item2, index2) {
                            return _c(
                              "p",
                              {
                                key: index2,
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-thumb",
                                  staticStyle: {
                                    "font-size": "0.19rem",
                                    transform: "rotate(90deg)",
                                  },
                                }),
                                _c("span", [_vm._v(" " + _vm._s(item2.name))]),
                                _vm.isEdit
                                  ? _c("el-input", {
                                      staticStyle: { width: "1.3rem" },
                                      attrs: {
                                        placeholder: "请输入新的报价",
                                        size: "mini",
                                      },
                                      model: {
                                        value: item2.price,
                                        callback: function ($$v) {
                                          _vm.$set(item2, "price", $$v)
                                        },
                                        expression: "item2.price",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v("  "),
                                _vm.isEdit
                                  ? _c("i", {
                                      staticClass: "el-icon-remove-outline",
                                      staticStyle: { "font-size": "0.19rem" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.deleteArrData(
                                            item1.roomInfo,
                                            item2,
                                            index2
                                          )
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          _c("p", [_vm._v(_vm._s(item1.vatAndCityTax))]),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                color: "red",
                                "font-weight": "bold",
                              },
                            },
                            [
                              !_vm.isEdit
                                ? _c("span", [
                                    _vm._v("Option:" + _vm._s(item1.option)),
                                  ])
                                : _c("el-date-picker", {
                                    staticStyle: { width: "1.7rem" },
                                    attrs: {
                                      format: "yyyy-MM-dd HH",
                                      type: "datetime",
                                      placeholder: "请输入option时间",
                                      "value-format": "yyyy-MM-dd HH",
                                    },
                                    model: {
                                      value: item1.option,
                                      callback: function ($$v) {
                                        _vm.$set(item1, "option", $$v)
                                      },
                                      expression: "item1.option",
                                    },
                                  }),
                            ],
                            1
                          ),
                          _c("p", [_vm._v(_vm._s(item1.cancelStr))]),
                        ],
                        2
                      )
                    }
                  ),
                ],
                2
              )
            }),
            0
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v(_vm._s(_vm.isEdit ? "保存" : "编辑"))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading.fullscreen.lock",
                      value: _vm.fullscreenLoading,
                      expression: "fullscreenLoading",
                      modifiers: { fullscreen: true, lock: true },
                    },
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.exportWord },
                },
                [_vm._v("word导出")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }